import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
/*--------------------------GET ANNOUNCEMENTS-----------------------------*/
export const getAnnouncements = createAsyncThunk(
  "announcements/get-announcements",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}website/announcements`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
